export function getFormEmbedCode(
  shortCode: string,
  contentDomain: string,
  formName: string,
): string {
  const formId = `form-${shortCode}`;
  // TODO: On localhost this doesn't work... will it work for preview on prod? #4945
  const url = `https://${contentDomain}/${shortCode}`;
  return `<div class="feathrBeeFormPreview" data-form-name="${formName}" id="${formId}"></div>
<script src="https://${contentDomain}/forms-js/embed.js"></script>
<script>
FeathrForms.generateForm({
  id: "${formId}",
  url: "${url}"
});
</script>`;
}

/**
 * Get the head script tag for embedding forms
 * This script should be added to the <head> of the site.
 */
export function getDonationFormHeadScript(contentDomain: string): string {
  return `<script defer crossorigin src="https://${contentDomain}/forms-js/embed-v2.js"></script>`;
}

/**
 * Get the div element where the inline form will appear.
 */
export function getInlineDonationFormDiv(formId: string): string {
  return `<div id="myForm" data-feathr-form="${formId}"></div>`;
}

/**
 * Get the complete inline embed code (all 3 parts combined).
 */
export function getInlineDonationFormEmbedCode(contentDomain: string, formId: string): string {
  return `${getDonationFormHeadScript(contentDomain)}

${getInlineDonationFormDiv(formId)}`;
}

/**
 * Get the modal form URL hash format.
 */
export function getModalDonationFormHash(formId: string): string {
  return `#modal-form-${formId}`;
}
